// React
import { useState } from 'react';

// Third-party libraries
import useTranslation from '@/utils/hooks/translation/useTranslation';
// Hooks
import useAcl from '@/utils/hooks/user/useAcl';

// Components
import Icon from '@/components/base/Icon';

type ActionItemProps = {
    action: {
        type: string;
        title: string;
        description: string;
        icon: string;
        hoverIcon: string;
        color: string;
        onClick: () => void;
        acl?: {
            permissions_plan_restriction: string[];
        };
    };
};

export const ActionItem = ({ action }: ActionItemProps) => {
    const { t } = useTranslation('home');
    const { hasAcl } = useAcl();
    const [isHovered, setIsHovered] = useState(false);

    const requiresPlanAbove =
        action?.acl?.permissions_plan_restriction &&
        !hasAcl(action.acl.permissions_plan_restriction);

    return (
        <button
            data-testid="action-item"
            className="flex cursor-pointer flex-row items-center gap-3 rounded-xl bg-white p-6 transition duration-200 dark:bg-icoDarkMode-anthracite"
            onClick={action.onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <div
                className={`flex h-10 w-10 items-center justify-center gap-2 rounded-lg bg-${action.color}-100`}>
                <Icon
                    className={`text-${action.color} text-2xl`}
                    icon={isHovered ? action.hoverIcon : action.icon}
                />
            </div>
            <div className="flex flex-col gap-1 p-2 text-left">
                <p className="flex items-center gap-1.5 font-GBold text-base">
                    {t(action.title)}
                    {requiresPlanAbove ? <Icon icon="crown" className="text-icoBlue" /> : null}
                    {isHovered && !requiresPlanAbove ? (
                        <Icon
                            data-testid="arrow-right"
                            icon="arrow-right"
                            className="text-icoGray-400"
                        />
                    ) : null}
                </p>
                <p className="font-GMedium text-sm text-icoGray-500">{t(action.description)}</p>
            </div>
        </button>
    );
};
